import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FreelanceHistoryComponent } from './freelanceHistory.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [FreelanceHistoryComponent],
  exports: [
    FreelanceHistoryComponent
  ],
  providers: [
  ]
})
export class FreelanceHistoryModule { }
